import { useCallback } from 'react';
import { Flex } from 'antd';
import { MAvatar, Status } from '@Components/Base';
import { useGetPurchaseRequestQuery } from '@Features/MaterialRequest/requests/PurchaseRequest/store/api/purchaseRequestApiSlice';
import { getModalRecordKey } from '@Store/selectors/modalSelector';
import { getPurchaseClassifications } from '@Store/selectors/dictionarySelector';
import { useAppSelector, useStatusFinderByNum } from '@Hooks/index';
import { useGetUsersListByNameQuery } from '@Store/api/userApiSlice';
import { useGetEmpPhotoQuery } from '@Store/api/dictionaryApiSlice';

import fieldSource from '../../FieldSource';

import styles from '../view-tab.module.css';

const DetailsTab: React.FC = () => {
  const { findStatus } = useStatusFinderByNum('Purchase');
  const requestId = useAppSelector(getModalRecordKey);
  const purchaseClassifications = useAppSelector(getPurchaseClassifications);
  const { data } = useGetPurchaseRequestQuery(requestId!, {
    skip: !requestId,
    refetchOnMountOrArgChange: true,
  });

  const userName = data?.approver || null;

  const { data: users = [] } = useGetUsersListByNameQuery(userName);

  const prOfficerUser =
    data && users.find((item) => item.empNumber === String(data?.approverNo));

  const { data: userPhoto } = useGetEmpPhotoQuery(
    prOfficerUser?.empImageName || ''
  );

  const findClassification = useCallback(
    (classificationId: number): string => {
      return (
        purchaseClassifications.find(
          (classification) => classification.codeNum === classificationId
        )?.codeDesc || ''
      );
    },
    [purchaseClassifications]
  );

  if (!data) return null;

  return (
    <>
      {fieldSource({
        data,
        findClassification,
      }).map((item) => (
        <div className={styles.viewItem} key={item.label}>
          <span>{item.label}</span>
          {item.label === 'Status' && (
            <Status
              className={styles.viewItemValue}
              text={findStatus(Number(item.value))?.codeDesc || ''}
            />
          )}
          {item.label === 'Purchase Officer' && (
            <Flex align="center">
              <MAvatar
                size={24}
                src={userPhoto}
                style={{ marginRight: '8px' }}
              />
              <span className={styles.viewItemValue}>{item.value}</span>
            </Flex>
          )}
          {item.label !== 'Purchase Officer' && item.label !== 'Status' && (
            <span className={styles.viewItemValue}>{item.value}</span>
          )}
        </div>
      ))}
    </>
  );
};

export default DetailsTab;
